 <app-table-title [introText]="introText" [title]="'TAX_FORMS' | dictionary"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;padding-top: 1px;padding-bottom: 1px;">
         <div class="form-row col-lg-12 pt-2 pb-2">

           <div class="col-md-6 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'FUND' | dictionary}}</label>
             <div style="padding: 0;width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="fund" (ngModelChange)="search()">
                 <option *ngFor="let fund of funds" [value]="fund.FundId">{{fund.Title}}</option>
               </select>
             </div>
           </div>
           <div class="col-sm-12 col-md-3">
             <label class="text-right text-color-1 filter-label-width">{{'TAX_YEAR' | dictionary}}</label>
             <div style="padding: 0;width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="year" (ngModelChange)="search()">
                 <option *ngFor="let year of years" [value]="year.Year">{{year.Title}}</option>
               </select>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>

 <div class="row table-container"  [class.with-padding-for-buttons]="rowSelectionList && rowSelectionList.length > 0">
   <div class="col-lg-12 table-container">
     <kendo-grid #kendoGridComponent
                 [data]="taxForms"
                 [loading]="loading"
                 [navigable]="true"
                 [sortable]="{allowUnsort: false, mode: 'single'}"
                 [(selectedKeys)]="rowSelectionList"
                 [kendoGridSelectBy]="'index'"
                 [sort]="sort"
                 (sortChange)="sortChange($event)"
                 [selectable]="true"
                 (scrollBottom)="loadMore()">
       <kendo-grid-checkbox-column *ngIf="canSelect" showSelectAll="true" [style]="{'text-align':'center'}"
                                   [headerClass]="'k-checkbox-all gridheader text-color-1'" [width]="25"
                                   field="Label1">
       </kendo-grid-checkbox-column>

       <kendo-grid-column [headerClass]="'gridheader  text-color-1'" field="Year" [width]="40" title="{{'YEAR' | dictionary}}">
       </kendo-grid-column>
       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="TaxStatement" [width]="90"
         title="{{'TAX_STATEMENT' | dictionary}}"></kendo-grid-column>
       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="FundTitle" [width]="60"
         title="{{'FUND' | dictionary}}"></kendo-grid-column>
       <kendo-grid-column [headerClass]="'gridheader  text-color-1'" field="SubscrTitle" [width]="100"
         title="{{'ACCOUNT' | dictionary}}"></kendo-grid-column>

       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="TaxGuide" title="{{'TAX_GUIDE' | dictionary}}" [sortable]="false"
         [width]="50">
         <ng-template kendoGridCellTemplate let-dataItem>

           <div class="download-icon"  *ngIf="dataItem.TaxGuide != 0" (click)="downloadDocumentForTax(dataItem.TaxGuide)">
             <i class="fas fa-landmark icon"></i>
           </div>
         </ng-template>
       </kendo-grid-column>

       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="DocSeqNum" title="{{'DOWNLOAD' | dictionary}}"  [sortable]="false"
         [width]="50" align="center">
         <ng-template kendoGridCellTemplate let-dataItem>

           <div class="download-icon"  *ngIf="dataItem.DocSeqNum != 0" (click)="prevent($event); downloadDocument(dataItem.DocSeqNum,dataItem.FileNum)">
             <i class="fas fa-file-download icon"></i>
           </div>

           <div class="download-icon"  *ngIf="dataItem.Location == 'D'" (click)="prevent($event); downloadDocumentDynamic(dataItem)">
             <i class="fas fa-file-download icon"></i>
           </div>
         </ng-template>
       </kendo-grid-column>
     </kendo-grid>
   </div>
 </div>

 <div class="download-wrapper"
      *ngIf="rowSelectionList && rowSelectionList.length > 0">
   <button type="button" class="button-1" (click)="downloadSelected()">
     <i class="fa fa-download"></i>
     <span *ngIf="rowSelectionList.length === 1"> {{'DOWNLOAD_FILE' | dictionary}}</span>
     <span
       *ngIf="rowSelectionList.length > 1"> {{'DOWNLOAD_FILES' | dictionary : ((isAllSelected ? totalRecords : rowSelectionList.length) || 0)}}</span>
   </button>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>

